import { updateView } from '@/backend/updateView'
import { useProjectStore } from '@/modules/Project/useProjectStore'
import { invariant } from '@/shared/utils/typeAssertions'

export const useShiftPropertyToIndex = () => {
  const projectStore = useProjectStore()

  const shiftPropertyToIndex = async (propertyId: string, newIndex: number) => {
    // optimistically update the properties in the store for instant feedback
    const { ok, oldPropertyIds } = projectStore.shiftPropertyToIndex(propertyId, newIndex)

    invariant(projectStore.activeView)

    if (!ok) return

    const result = await updateView({
      workspaceId: projectStore.activeView.view.workspaceId,
      projectId: projectStore.activeView.view.projectId,
      viewId: projectStore.activeView.id,
      name: projectStore.activeView.view.name,
      propertyIds: projectStore.activeView.view.propertyIds ?? [],
      propertyLayouts: projectStore.activeView.view.propertyLayouts,
      filters: projectStore.activeView.view.filters,
      propertyOptions: projectStore.activeView.view.propertyOptions ?? [],
      assignablePropertyId: projectStore.activeView.view.assignablePropertyId,
      numPinnedProperties: projectStore.activeView.view.numPinnedProperties,
    })

    if (!result.ok && oldPropertyIds) {
      // rollback the change if the update failed
      projectStore.upsertView({
        id: projectStore.activeView.id,
        propertyIds: oldPropertyIds,
        propertyLayouts: projectStore.activeView.view.propertyLayouts,
        filters: projectStore.activeView.view.filters,
        name: projectStore.activeView.view.name,
        propertyOptions: projectStore.activeView.view.propertyOptions,
        assignablePropertyId: projectStore.activeView.view.assignablePropertyId,
        numPinnedProperties: projectStore.activeView.view.numPinnedProperties,
        projectId: projectStore.activeView.view.projectId,
        workspaceId: projectStore.activeView.view.workspaceId,
      })
    }
  }

  return {
    shiftPropertyToIndex,
  }
}
